import EmberService, { service } from '@ember/service';

import type { ReactNode, Root } from '@databox/ember-integrations/lib/components/Setup';
import { create, render, unmount } from '@databox/ember-integrations/lib/components/Setup';

import type { Service } from 'webapp-types';

export default class ReactService extends EmberService {
	@service('navigation') declare navigationService: Service.Navigation;

	create(node: HTMLDivElement): Root {
		return create(node);
	}

	render(root: Root, children: ReactNode, mode?: 'open' | 'closed'): void {
		render(root, children, this.navigationService.theme.isDark, mode);
	}
	// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents -- Root resolves to any from ember-integrations
	unmount(root: Root | null): void {
		if (root) {
			unmount(root);
			root = null;
		}
	}
}

declare module '@ember/service' {
	interface Registry {
		react: ReactService;
	}
}
